"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DFU_SERVICE = exports.LOG_SERVICE = exports.VAPING_SERVICE = exports.DeviceCharacteristics = void 0;
/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-shadow
var DeviceCharacteristics;
(function (DeviceCharacteristics) {
    DeviceCharacteristics["DEVICE_INFORMATION"] = "6cd6c8b5-e378-0103-010a-1b9740683449";
    DeviceCharacteristics["TIME"] = "6cd6c8b5-e378-0103-020a-1b9740683449";
    DeviceCharacteristics["BATTERY"] = "6cd6c8b5-e378-0103-030a-1b9740683449";
    DeviceCharacteristics["LOCK"] = "6cd6c8b5-e378-0103-040a-1b9740683449";
    DeviceCharacteristics["PUFF_RECORDS"] = "6cd6c8b5-e378-0103-060a-1b9740683449";
    DeviceCharacteristics["FIND_MY_VAPE"] = "6cd6c8b5-e378-0103-090a-1b9740683449";
    DeviceCharacteristics["LED"] = "6cd6c8b5-e378-0103-0a0a-1b9740683449";
    DeviceCharacteristics["CLOUD_CONTROL"] = "6cd6c8b5-e378-0103-0c0a-1b9740683449";
    DeviceCharacteristics["FACTORY_RESET"] = "6cd6c8b5-e378-0103-0b0a-1b9740683449";
    DeviceCharacteristics["EVENT_LOG_RECORD"] = "6cd6c8b5-e378-0103-030b-1b9740683449";
    DeviceCharacteristics["LAST_ERROR_RECORD"] = "6cd6c8b5-e378-0103-010b-1b9740683449";
    DeviceCharacteristics["BUTTON_LESS"] = "8ec90003-f315-4f60-9fb8-838830daea50";
})(DeviceCharacteristics = exports.DeviceCharacteristics || (exports.DeviceCharacteristics = {}));
exports.VAPING_SERVICE = '6cd6c8b5-e378-0103-000a-1b9740683449';
exports.LOG_SERVICE = '6cd6c8b5-e378-0103-000b-1b9740683449';
exports.DFU_SERVICE = '0000fe59-0000-1000-8000-00805f9b34fb';
